import React, { useState } from "react";
import LenderRow from "./LenderRow";
import SelectedLenderSummary from "./SelectedLenderSummary";
import LockInfo from "./LockInfo";
import PlanDetailsPanel from "./PlanDetailsPanel";
import ExpanderButton from "./PaymentPlanCard/parts/ExpanderButton";
import { getOfferPromo } from "../../helpers";
import "./styles.scss";

const LenderList = ({
  offers,
  cartTotal,
  selectedLenderProvider,
  onSelectLender,
}) => {
  const [offersExpanded, setOffersExpanded] = useState(false);
  const [planExpanded, setPlanExpanded] = useState(false);

  const selectedOffer =
    offers.find((o) => o.specific_provider_name === selectedLenderProvider) ||
    null;
  const hasOtherOffers = offers.length > 1;

  const handleSelect = (provider) => {
    onSelectLender(provider);
    setOffersExpanded(false);
  };

  return (
    <div className="lender-select">
      {selectedOffer && (
        <SelectedLenderSummary
          offer={selectedOffer}
          cartTotal={cartTotal}
          canToggle={hasOtherOffers}
          expanded={offersExpanded}
          onToggle={() => setOffersExpanded((prev) => !prev)}
        />
      )}

      {offersExpanded && hasOtherOffers && (
        <div className="lender-select__offers">
          <div className="lender-select__offers-head">
            You&apos;re approved by {offers.length} lenders — pick one
          </div>
          <ul className="lender-select__rows">
            {offers.map((offer) => (
              <LenderRow
                key={offer.specific_provider_name}
                offer={offer}
                isSelected={
                  offer.specific_provider_name === selectedLenderProvider
                }
                cartTotal={cartTotal}
                onSelect={handleSelect}
                promo={getOfferPromo(offer, cartTotal)}
              />
            ))}
          </ul>
        </div>
      )}

      <LockInfo />

      {selectedOffer && (
        <div className="lender-select__plan">
          <ExpanderButton
            isExpanded={planExpanded}
            onToggle={() => setPlanExpanded((prev) => !prev)}
          />
          {planExpanded && (
            <PlanDetailsPanel offer={selectedOffer} cartTotal={cartTotal} />
          )}
        </div>
      )}
    </div>
  );
};

export default LenderList;
